export default {
  all: {
    id: 'listings_all',
    defaultMessage: 'All',
  },
  // grades
  gradesAll: {
    id: 'listings_state_all',
    defaultMessage: 'All grades',
  },
  gradeShiny: {
    id: 'grade_shiny',
    defaultMessage: 'Mint',
  },
  gradeGold: {
    id: 'grade_gold',
    defaultMessage: 'Very good',
  },
  gradeSilver: {
    id: 'grade_silver',
    defaultMessage: 'Good',
  },
  gradeBronze: {
    id: 'grade_bronze',
    defaultMessage: 'Fair',
  },
  gradeStallone: {
    id: 'grade_stallone',
    defaultMessage: 'Stallone',
  },

  // backbox
  backboxAll: {
    id: 'listings_buybox_all',
    defaultMessage: 'With and without buybox',
  },
  withBackbox: {
    id: 'listings_with_buybox',
    defaultMessage: 'With Buybox',
  },
  withoutBackbox: {
    id: 'listings_without_buybox',
    defaultMessage: 'Without Buybox',
  },

  // stock
  withAndWithoutStock: {
    id: 'listings_with_and_without_stock',
    defaultMessage: 'With and without stock',
  },
  withStock: {
    id: 'listings_with_stock',
    defaultMessage: 'With stock',
  },
  withoutStock: {
    id: 'listings_without_stock',
    defaultMessage: 'Without stock',
  },

  // alerts
  alertsAll: {
    id: 'listings_alerts_all',
    defaultMessage: 'All alerts',
  },
  priceAboveNew: {
    id: 'listings_price_above_new',
    defaultMessage: 'Price > New price',
  },

  // markets
  marketsAll: {
    id: 'listings_markets_all',
    defaultMessage: 'All markets',
  },
  marketsSelected: {
    id: 'bo_seller.listings.filters.market_filter.number_of_markets_selected',
    defaultMessage: '{numberOfMarkets} selected',
  },

  // pricing strategy
  deal: {
    id: 'bo_seller.listings.listings_filters.pricing_strategy_options.deal',
    defaultMessage: 'Deal',
  },

  // categories
  categoryAll: {
    id: 'listings_category_all',
    defaultMessage: 'All categories',
  },

  // backbox price range type
  backboxPriceRangeTypeCaption: {
    id: 'listings_backbox_price_range_type_caption',
    defaultMessage:
      'See listings priced within a custom range from winning BackBoxes.',
  },
  backboxPriceRangeTypeAmount: {
    id: 'listings_backbox_price_range_type_amount',
    defaultMessage: 'Amount',
  },
  backboxPriceRangeTypePercentage: {
    id: 'listings_backbox_price_range_type_percentage',
    defaultMessage: 'Percentage (%)',
  },
  backboxPriceRangeTypeApply: {
    id: 'listings_backbox_price_range_type_apply',
    defaultMessage: 'Apply',
  },
  backboxPriceRangeTypeReset: {
    id: 'listings_backbox_price_range_type_reset',
    defaultMessage: 'Reset',
  },
  backboxPriceRangeType: {
    id: 'listings_backbox_price_range_type',
    defaultMessage: 'BackBox Price Difference',
  },
  backboxPriceRangeTypeMin: {
    id: 'listings_backbox_price_range_type_min_percentage.label',
    defaultMessage: 'Min. (%)',
  },
  backboxPriceRangeTypeMax: {
    id: 'listings_backbox_price_range_type_max_percentage.label',
    defaultMessage: 'Max. (%)',
  },
  backboxPriceRangeTypeCurrency: {
    id: 'listings_backbox_price_range_type_currency.label',
    defaultMessage: 'Select currency',
  },
  backboxPriceRangeTypeMinAmount: {
    id: 'listings_backbox_price_range_type_min_amount.label',
    defaultMessage: 'Min. ({currency})',
  },
  backboxPriceRangeTypeMaxAmount: {
    id: 'listings_backbox_price_range_type_max_amount.label',
    defaultMessage: 'Max. ({currency})',
  },

  // quick filters
  backboxPriceRangeButton: {
    id: 'listings_backbox_price_range_button',
    defaultMessage: 'See all within {priceRange} of BackBoxes',
  },
  dealOpportunitiesButton: {
    id: 'bo_seller.listings.listings_quick_filters.deal_opportunities_button',
    defaultMessage: 'See all deal opportunities',
  },

  // battery type
  hasNewBatteryAll: {
    id: 'listings_battery_type_all',
    defaultMessage: 'All type',
  },
  hasNewBatteryNew: {
    id: 'listings_battery_type_new',
    defaultMessage: 'New',
  },
  hasNewBatteryRefurbished: {
    id: 'listings_battery_type_refurbished',
    defaultMessage: 'Refurbished',
  },
  // filters
  title: {
    id: 'listings_title_label',
    defaultMessage: 'Title',
  },
  sku: {
    id: 'listings_sku_label',
    defaultMessage: 'SKU',
  },
  uuid: {
    id: 'listings_uuid_label',
    defaultMessage: 'Uuid',
  },
  grade: {
    id: 'listings_grade_label',
    defaultMessage: 'Grade',
  },
  backbox: {
    id: 'listings_buybox_label',
    defaultMessage: 'Buybox',
  },
  stock: {
    id: 'listings_stock_label',
    defaultMessage: 'Stock',
  },
  alerts: {
    id: 'listings_alerts_label',
    defaultMessage: 'Alerts',
  },
  markets: {
    id: 'bo_seller.listings.listings_filters.markets',
    defaultMessage: 'Market(s)',
  },
  pricingStrategy: {
    id: 'bo_seller.listings.listings_filters.pricing_strategy',
    defaultMessage: 'Pricing strategy',
  },
  submit: {
    id: 'listings_apply_filters',
    defaultMessage: 'Apply filters',
  },
  resetFilters: {
    id: 'listings_reset_filters',
    defaultMessage: 'Reset',
  },
  showMoreFilters: {
    id: 'listings_show_more_filters',
    defaultMessage: 'Show more filters',
  },
  showLessFilters: {
    id: 'listings_show_less_filters',
    defaultMessage: 'Show less filters',
  },
  category: {
    id: 'listings_category_label',
    defaultMessage: 'Category',
  },
  hasNewBattery: {
    id: 'listings_category_battery_type',
    defaultMessage: 'Battery Type',
  },
  backmarketId: {
    id: 'listings_backmarket_id_label',
    defaultMessage: 'Back Market ID',
  },
  filter: {
    id: 'listings_mobile_filters_filter',
    defaultMessage: 'Filter',
  },
  viewResults: {
    id: 'listings_mobile_filters_view_results',
    defaultMessage: `View {hasFiltersSelected, select,
      true {filtered results}
      other {results}
    }`,
  },
} as const
